import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class AnalyticsService {

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient) { }


  getConsignmentsAnalytics(data){
    let config = {
      headers: new HttpHeaders({'Content-Type':'application/json'})
  };
  console.log(data);
  return this.http.get('/consignments/getConsignmentAnalytics?startDate='+data.startDate+'&endDate='+data.endDate+'&scale='+data.scale, config);
  }

  getShipmentsAnalytics(data){
    let config = {
      headers: new HttpHeaders({'Content-Type':'application/json'})
  };
  return this.http.get('/shipments/getShipmentAnalytics?startDate='+data.startDate+'&endDate='+data.endDate+'&scale='+data.scale,config);
  }


  getTripsAnalytics(data){
    let config = {
      headers: new HttpHeaders({'Content-Type':'application/json'})
  };

  return this.http.get('/trips/getTripAnalytics?startDate='+data.startDate+'&endDate='+data.endDate+'&scale='+data.scale,config);
  }



}



// WEBPACK FOOTER //
// ./src/app/services/analytics/analytics.service.ts